import '@utils/jsExtentions';
import '@fontsource/roboto/latin.css';
import '@fontsource/noto-sans-hebrew/hebrew.css';
import '@fontsource/material-symbols-outlined';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
